import produce from 'immer'
import * as ActionTypes from 'actions/ActionTypes'

const initialState = {
  extentions: [],
  activeExtensions: [],
}

const setExtentions = (state, action) => {
  const { extentions } = action.payload
  state.extentions = extentions
}

const openExtension = (state, action) => {
  const { extension } = action.payload
  const exists = state.activeExtensions.some(ext => ext.menu === extension.menu)
  if (!exists) {
    state.activeExtensions.push(extension)
  }
}

const closeExtension = (state, action) => {
  const { extensionId } = action.payload
  state.activeExtensions = state.activeExtensions.filter(ext => ext.menu !== extensionId)
}

const adobeCepExtentions = (state, action) => {
  // eslint-disable-next-line default-case
  switch (action.type) {
    case ActionTypes.SET_ADOBE_CEP_EXTENTIONS:
      setExtentions(state, action)
      break
    case ActionTypes.OPEN_CEP_EXTENSION:
      openExtension(state, action)
      break
    case ActionTypes.CLOSE_CEP_EXTENSION:
      closeExtension(state, action)
      break
  }
}

export default produce(adobeCepExtentions, initialState)
